// fallow-ignore-next-line boundary-violation -- shared sales helper lives in workspace zone; move pending
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { DynamicsPreDefinedType, PreDefinedResponse } from "../../types/shared";

export type { DynamicsPreDefinedType } from "../../types/shared";

export type DynamicsPredefinedApiServiceType = {
    getDynamicsPreDefinedColumns(type: DynamicsPreDefinedType, cacheToken: string): Promise<PreDefinedResponse>;
};

export const dynamicsPredefinedApiService = (fetchService: IFetchService): DynamicsPredefinedApiServiceType => {
    return {
        getDynamicsPreDefinedColumns: createCancelable(
            (signal: AbortSignal, type: DynamicsPreDefinedType, cacheToken: string): Promise<PreDefinedResponse> => {
                return fetchService.get(
                    `sales-api/microsoft-dynamics/predefined-${type}-columns?cacheToken=${cacheToken}`,
                    undefined,
                    {
                        cancellation: signal,
                    },
                );
            },
        ),
    };
};
